
import { FamilyMember } from '@/types';
import { generateId } from '../generators';

export function addChildToTree(
  parentId: string,
  childName: string,
  members: FamilyMember[]
): { newChild: FamilyMember; updatedParent: FamilyMember | null } {
  const newChild: FamilyMember = {
    id: generateId(),
    name: childName,
    parentId,
    children: [],
  };

  const parent = members.find(m => m.id === parentId);
  const updatedParent = parent ? {
    ...parent,
    children: [...parent.children, newChild.id]
  } : null;

  return { newChild, updatedParent };
}

export function getDescendants(memberId: string, members: FamilyMember[]): string[] {
  const member = members.find(m => m.id === memberId);
  if (!member) return [];

  const descendants = [...member.children];
  member.children.forEach(childId => {
    descendants.push(...getDescendants(childId, members));
  });

  return descendants;
}

export function isDescendant(
  memberId: string,
  ancestorId: string,
  members: FamilyMember[]
): boolean {
  return getDescendants(ancestorId, members).includes(memberId);
}
